import scrollToElement from 'scroll-to-element';
import formAttachValidation from './form';

const formAutocomplete = function autoComplete() {
    const form = document.querySelector('.section-form form');
    const name = form.querySelectorAll('input[name="paywall[name]"]');
    const email = form.querySelectorAll('input[name="paywall[email]"]');
    function getQueryVariable(variable) {
        const query = decodeURIComponent(window.location.search.substring(1));
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i += 1) {
            const pair = vars[i].split('=');
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return false;
    }
    const valName = getQueryVariable('name');
    const valEmail = getQueryVariable('email');
    if (valEmail) {
        name[0].classList.add('not-empty');
        name[0].value = valName;
    }
    if (valEmail) {
        email[0].classList.add('not-empty');
        email[0].value = valEmail;
    }
};

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    formAutocomplete();

    if (document.querySelector('.section-form form')) {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting === true) {
                formAttachValidation();
                observer.unobserve(document.querySelector('.section-form form'));
            }
        }, {});
        observer.observe(document.querySelector('.section-form form'));
    }
    [].forEach.call(document.querySelectorAll('a[data-anchor]'), (anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
            if (typeof anchor !== 'undefined' && anchor != null) {
                e.preventDefault();
                const target = anchor.getAttribute('href');
                scrollToElement(document.querySelector(target), {
                    offset: -50,
                    duration: 500,
                });
            }
        });
    });
});
